import { queryClient } from '../queryClient';

export function onRent() {
  queryClient.invalidateQueries({
    predicate: (query) => query.queryKey[0] === 'RENTALS' || query.queryKey[0] === 'COLLECTION',
  });
}
